import { render } from "./Icon.vue?vue&type=template&id=649c5d9e&scoped=true"
import script from "./Icon.vue?vue&type=script&lang=js"
export * from "./Icon.vue?vue&type=script&lang=js"

import "./Icon.vue?vue&type=style&index=0&id=649c5d9e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-649c5d9e"

export default script